module.exports = __webpack_public_path__ + "static/marketing-3f269f9a51512c9631ab74934b09552f.png";